import { Ref } from 'vue';
import useMarkerLayer from './useMarkerLayer';
// import usePolylineLayer from './usePolylineLayer';
// import usePolygonLayer from './usePolygonLayer';
// import useHeatLayer from './useHeatLayer';
// import useModelLayer from './useModelLayer';
// import useLabelLayer from './useLabelLayer';
import useHDRoadModelLayer from './useHDRoadModelLayer';
// import useRadiationLayer from './useRadiationLayer';
import useTrackLayer from './useTrackLayer';
// import useTrafficSignalLayer from './useTrafficSignalLayer';

const LayerTypeHandlerMap = {
  marker: useMarkerLayer,
  // polyline: usePolylineLayer,
  // polygon: usePolygonLayer,
  // heat: useHeatLayer,
  // model: useModelLayer,
  HDRoadModel: useHDRoadModelLayer,
  // radiation: useRadiationLayer,
  track: useTrackLayer,
  // trafficSignal: useTrafficSignalLayer,
};


let layerInstanceList: LooseObject[] = [];
export default function useLayerManager(mapInstance: LooseObject | null, layerList: Ref<MapLayer[]>): {
  clearAllLayers?: () => void
} {
  if (!mapInstance) return {};

  layerList.value.forEach((layer: MapLayer, index: number) => {
    const { type } = layer;
    const layerInstance = LayerTypeHandlerMap[type]?.(mapInstance, toRef(layerList.value, index));

    // watch(() => layerList.value[index], (newLayer) => {
    //   layerInstance?.destroy();
    //   layerInstance = null;
    //   if (newLayer) {
    //     layerInstance = LayerTypeHandlerMap[type](mapInstance, newLayer);
    //   }
    // });
    layerInstanceList.push(layerInstance);
  });

  const clearAllLayers = (): void => {
    layerInstanceList.forEach((instance) => {
      instance?.unmount();
    });
    layerInstanceList = [];
  };

  return {
    clearAllLayers,
  };
}
